import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { PopupService } from './popup.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/Rx';
import { LoaderService } from './loader.service';
import { PropertyService } from './property.service';
import { Observable } from 'rxjs';

@Injectable()
export class RetailerService {

  myRetailers: any[] = [];
  pageNumber: number = 1;
  recordsPerPage: number = 10;
  allFetched: boolean = false;
  searchValue: string = '';
  isFetching: boolean = false;
  isDeletedFetching: boolean = false;

  myDeletedRetailers: any[] = [];
  deletedPageNumber: number = 1;
  allDeletedFetched: boolean = false;
  deletedSearchValue: string = '';

  retailersContainerElement: any;
  retailersInputElement: any;

  fetchRetailersSource = new BehaviorSubject<boolean>(false);
  fetchRetailersStream = this.fetchRetailersSource.asObservable();

  constructor(public httpClient: HttpClient, public baseService: BaseService, public popupService: PopupService,
              public loaderService : LoaderService, public propertyService : PropertyService) { }

  getMyRetailers() {
    return this.httpClient.get(environment.APP.API_URL+'/my/retailer/location?recordsPerPage=' +
     this.recordsPerPage + '&pageNumber=' + this.pageNumber + '&name=' + encodeURIComponent(this.searchValue))
      .map((res: any) => {
        (res.length === this.recordsPerPage) ? this.pageNumber++ : this.allFetched = true;
        return res;
      });
  }

  getMyDeletedRetailers() {
    return this.httpClient.get(environment.APP.API_URL+'/my/retailer/location?deleted=true&recordsPerPage=' +
     this.recordsPerPage + '&pageNumber=' + this.deletedPageNumber + '&name=' + encodeURIComponent(this.deletedSearchValue))
      .map((res: any) => {
        (res.length === this.recordsPerPage) ? this.deletedPageNumber++ : this.allDeletedFetched = true;
        return res;
      });
  }

  goToRetailer(retailer) {
    let w = (<any>window);
    w.map.setOptions({
      center: new w.google.maps.LatLng(retailer.geom.coordinates[1],retailer.geom.coordinates[0]),
      zoom: 18
    });
    this.popupService.updateRoute();
  }

  resetPagination() {
    this.allFetched = false;
    this.myRetailers = [];
    this.pageNumber = 1;
  }

  resetDeletedPagination() {
    this.allDeletedFetched = false;
    this.myDeletedRetailers = [];
    this.deletedPageNumber = 1;
  }

  searchRetailers() {
    this.resetPagination();
    (<any>window).Events.publish('detectChanges');
    this.fetchRetailers();
  }

  fetchRetailers() {
    if(!this.allFetched && !this.isFetching) {
      this.isFetching = true;
      this.loaderService.addGreyLoaderClass();
      this.getMyRetailers().subscribe((response)=> {
        this.isFetching = false;
        for(var i = 0; i < response.length; i++) {
          this.myRetailers.push(response[i]);
          !this.retailersInputElement && this.addInputEventObservable();
          (<any>window).Events.publish('detectChanges');
        }
        this.loaderService.removeGreyLoaderClass();
      },(error)=>{
        this.isFetching = false;
        this.loaderService.removeGreyLoaderClass();
        throw(error);
      });
    }
  }

  addInputEventObservable() {
    this.retailersInputElement = document.getElementById('retailers-search-input');
    if(this.retailersInputElement) {
      Observable.fromEvent(this.retailersInputElement, 'input')
        .debounceTime(500)
        .subscribe((event) => {
          this.searchRetailers();
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/retailer.service.ts